<template>
    <a-card 
            size="small" 
            title="日志信息" 
            style='margin-top:20px'
            :headStyle='{
                background : "#f3f3f3"
            }'
            class='logContent'

        >
        <a-table :columns="columns" bordered 
            :data-source="list"
            :pagination='false' 
            
            :row-key="r => r.id"
            >   
            <template v-slot:index="{ text,record,index }">
            {{list.length - index}}
        
            </template>

          <template v-slot:data="{ text,record,index }">
            {{text}}
            <a-button v-if="record.showCall"  @click="showJsonDetail(record.callJson)">查看参数</a-button>
          </template>
            

        </a-table>
    </a-card>



  <a-modal v-model:visible="isShowCallInfo" title="参数信息" @ok="handOk">
<!--    <json-viewer :value="jsonData" copyable boxed sort />-->
    {{jsonData}}
  </a-modal>


</template>
<script>

import { ref, reactive, provide } from "vue";


export default {
    componentname: "orderLog",
    props:{
        list:{
            type:Array,
            default:function(){
                return []
            }
        },
    },
  updated() {
    this.list.forEach(item => {
      if (item.operatorName === '' || item.operatorName === undefined){
        item.operatorName = 'System'
      }
      if (item.data.includes("call#")){
        const infos = item.data.split("call#")
        item.data = item.data.split("call#")[0]
        item.showCall = true
        item.callJson = infos[1]
      }
    })
  },
  setup(props){
       const isShowCallInfo = ref(false);
       const jsonData = ref("{}");

       const handOk = () => {
         isShowCallInfo.value = false;
       }

      /**
       * 展示日志记录的详细信息
       * @param jsonInfo
       */
      const showJsonDetail = (jsonInfo) => {
        console.log("sadsadsa",jsonInfo)
        isShowCallInfo.value = true
        jsonData.value = JSON.parse(jsonInfo)
         }
      return {
          columns : [
              {
                  title: '序号',
                  dataIndex: 'index',
                  width: 10,
                  align : 'center',
                  slots: { customRender: 'index' },
              },
              {
                  title: '操作人',
                  dataIndex: 'operatorName',
                  width: 100,
                  align : 'center',

              },
              {
                  title: '操作时间',
                  dataIndex: 'createTime',
                  width: 100,
                  align : 'center',

              },
              {
                  title: '操作内容',
                  dataIndex: 'data',
                  width: 300,
                  align : 'center',
                  slots: { customRender: 'data' },
              },

          ],
        isShowCallInfo,
        handOk,
        showJsonDetail,
        jsonData
      }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .logContent /deep/ .ant-card-body{
        padding:0!important;
    }
  
</style>






  